import { BannerFieldsFragment } from '../../../@types/generated';
import Button, { variantFromString } from 'components/src/button';
import Link from 'next/link';
import { getOr } from '@/utils/options';
import typewriter, { Placement, Title } from '@/analytics/segment';
import { useSetAtom } from 'jotai';
import { isDoBusinessWithUsFormAtom } from '@/store';

type Props = {
  data: BannerFieldsFragment['button'];
  classes?: string;
};

const ButtonSection = ({ data, classes = '' }: Props) => {
  const setIsDoBusinessWithUsForm = useSetAtom(isDoBusinessWithUsFormAtom);

  if (!data) {
    return;
  }

  return (
    <div className={classes}>
      {data.uri ? (
        <Link href={data.uri}>
          <Button label={getOr(data?.label, '')} variant={variantFromString(data?.variant)} />
        </Link>
      ) : (
        // If no link is provided, open the "Komdu í viðskipti" form
        <Button
          label={getOr(data?.label, '')}
          variant={variantFromString(data?.variant)}
          onClick={() => {
            typewriter.doBusinessWithUsButtonClicked({
              placement: Placement.PhotoAndTextCard,
              title: Title.KomduÍViðskipti,
            });
            setIsDoBusinessWithUsForm(true);
          }}
        />
      )}
    </div>
  );
};
export default ButtonSection;
